import { t } from "@lingui/macro";
import React from "react";

import {
  Text,
  HStack,
  Pressable,
} from "@whoosh/design-system/src/components/primitive";

import { AgendaItemContainer } from "../AgendaItemContainer";

type AvailableCardProps = {
  durationMins: number;
  onPress: () => void;
  courseName: string;
  time: string;
};

export const AvailableCard = ({
  durationMins,
  onPress,
  courseName,
  time,
}: AvailableCardProps) => {
  return (
    <AgendaItemContainer durationMins={durationMins}>
      <Pressable
        width="100%"
        height="100%"
        onPress={onPress}
        testID={`multi-slot-available-card-${courseName}-${time}`}
      >
        <HStack
          bg="surface-main-primary-subtlest"
          height="100%"
          width="100%"
          borderRadius="2"
          p={4}
          alignItems="center"
        >
          <Text
            maxFontSizeMultiplier={2}
            variant="mainSmallSemiBold"
            color="main-primary-800"
          >
            {t`Available`}
          </Text>
        </HStack>
      </Pressable>
    </AgendaItemContainer>
  );
};
